import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { GTMService } from '@services';
import { BookingStore } from '@store';
import { SimulateBookingFormGroup } from './simulate-booking.helper';

@Component({
  selector: 'app-simulate-booking',
  templateUrl: './simulate-booking.component.html',
  styleUrls: ['./simulate-booking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimulateBookingComponent implements OnInit {
  formGroup: FormGroup<SimulateBookingFormGroup> = new FormGroup<SimulateBookingFormGroup>({
    boilerSerial: new FormControl<string | null>(null, [Validators.required]),
    companyId: new FormControl<string | null>(null, [Validators.required]),
  });
  errorKey: string;
  errorDetails: string;
  isSimulationTriggered = false;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(public gtmService: GTMService, public bookingStore: BookingStore) {}

  ngOnInit(): void {
    this.bookingStore.subscriptionSimulatedError$
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        filter((error) => error !== null)
      )
      .subscribe((error) => {
        this.errorKey = this.mapError(error);
      });
  }

  simulateSubscription(): void {
    this.isSimulationTriggered = true;
    this.errorKey = null;
    this.errorDetails = null;
    this.bookingStore.simulateSubscription(
      this.formGroup.controls.boilerSerial.value,
      this.formGroup.controls.companyId.value
    );
  }

  private mapError(error: any): string {
    if (error.statusCode === 404) {
      switch (error.extendedPayload?.resourceType) {
        case 'boilerSerial':
        case 'boilerId': {
          return '+VOUCHERS.BOOKING_SIMULATION.ERROR.DEVICE_NOT_FOUND';
        }
        case 'Company':
        case 'companyId': {
          return '+VOUCHERS.BOOKING_SIMULATION.ERROR.COMPANY_NOT_FOUND';
        }
      }
    }

    if (error.statusCode === 409) {
      return '+VOUCHERS.BOOKING_SIMULATION.ERROR.ALREADY_BOOKED';
    }

    this.errorDetails = error.privateDetails?.errorMessage;

    return '+VOUCHERS.BOOKING_SIMULATION.ERROR.UNKNOWN_ERROR';
  }
}
